<template>
  <div class="box vh-140">
    <div class="box-header">
      <h3 class="box-title"><i class="fa fa-th-large"></i> 表单列表</h3>
      <div class="box-tools">
        <el-button class="pull-right" size="mini" round @click="goBack()" plain>
          <i class="fa fa-reply"></i> 返回
        </el-button>
      </div>
    </div>

    <div class="box-body" style="height: 800px">
        <fm-making-form
                ref="makingform"
                style="height: 500px;"
                :basic-fields="['input', 'textarea','radio','select']"
                :advance-fields="['blank', 'fileupload']"
                class="evl-marking"
        >
          <template slot="action">
            <!-- 自定义操作区域插槽 -->
            <el-button type="text" @click="handleSubmit" icon="el-icon-upload">保存</el-button>
          </template>
        </fm-making-form>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { get,update } from "@api/evaluation/form";
  import { GenerateForm, MakingForm } from 'form-making'
  import 'form-making/dist/FormMaking.css'

  Vue.use(GenerateForm)
  Vue.use(MakingForm)

  export default {
    name: '',
    data() {
      return {
        jsonData:{
          "list":[
            {
              "type":"input",
              "icon":"icon-input",
              "options":{
                "width":"100%",
                "defaultValue":"",
                "required":true,
                "dataType":"string",
                "pattern":"",
                "placeholder":"",
                "customClass":"",
                "disabled":false,
                "labelWidth":100,
                "isLabelWidth":false,
                "hidden":false,
                "dataBind":true,
                "showPassword":false,
                "remoteFunc":"func_1575897887618",
                "remoteOption":"option_1575897887618"
              },
              "name":"姓名",
              "key":"1575897887618",
              "model":"name",
              "rules":[
                { "type":"string", "message":"姓名格式不正确"},
                { "required":true, "message":"姓名必须填写" }
              ]
            },
            {
              "type":"input",
              "icon":"icon-input",
              "options":{
                "width":"100%",
                "defaultValue":"",
                "required":false,
                "dataType":"string",
                "pattern":"",
                "placeholder":"",
                "disabled":false,
                "remoteFunc":"func_1603087915000_59752"
              },
              "name":"公司",
              "key":"1603087915000_59752",
              "model":"companyName",
              "rules":[
                {
                  "type":"string",
                  "message":"公司名称格式不正确"
                }
              ]
            },
            {
              "type":"input",
              "icon":"icon-input",
              "options":{
                "width":"100%",
                "defaultValue":"",
                "required":false,
                "dataType":"string",
                "pattern":"",
                "placeholder":"",
                "disabled":false,
                "remoteFunc":"func_1603087944000_31814"
              },
              "name":"手机号",
              "key":"1603087944000_31814",
              "model":"phone",
              "rules":[
                {
                  "type":"string",
                  "message":"手机号格式不正确"
                }
              ]
            },
            {
              "type":"input",
              "icon":"icon-input",
              "options":{
                "width":"100%",
                "defaultValue":"",
                "required":false,
                "dataType":"string",
                "pattern":"",
                "placeholder":"",
                "disabled":false,
                "remoteFunc":"func_1603088010000_63563"
              },
              "name":"部门",
              "key":"1603088010000_63563",
              "model":"department",
              "rules":[
                {
                  "type":"string",
                  "message":"部门格式不正确"
                }
              ]
            },
            {
              "type":"input",
              "icon":"icon-input",
              "options":{
                "width":"100%",
                "defaultValue":"",
                "required":false,
                "dataType":"string",
                "pattern":"",
                "placeholder":"",
                "disabled":false,
                "remoteFunc":"func_1603088042000_75838"
              },
              "name":"年龄",
              "key":"1603088042000_75838",
              "model":"age",
              "rules":[
                {
                  "type":"string",
                  "message":"年龄格式不正确"
                }
              ]
            },
            {
              "type":"select",
              "icon":"icon-select",
              "options":{
                "defaultValue":"小学",
                "multiple":false,
                "disabled":false,
                "clearable":false,
                "placeholder":"",
                "required":false,
                "showLabel":false,
                "width":"",
                "options":[
                  {
                    "value":"小学"
                  },
                  {
                    "value":"初中"
                  },
                  {
                    "value":"高中"
                  },
                  {
                    "value":"本科"
                  },
                  {
                    "value":"研究生"
                  },
                  {
                    "value":"博士"
                  },
                  {
                    "value":"其他"
                  },
                  {
                    "value":"专科"
                  }
                ],
                "remote":false,
                "filterable":false,
                "remoteOptions":[

                ],
                "props":{
                  "value":"value",
                  "label":"label"
                },
                "remoteFunc":"func_1603088061000_92644"
              },
              "name":"学历",
              "key":"1603088061000_92644",
              "model":"degree",
              "rules":[

              ]
            },
            {
              "type":"radio",
              "icon":"icon-radio-active",
              "options":{
                "inline":false,
                "defaultValue":"Option 1",
                "showLabel":false,
                "options":[
                  {
                    "value":"男",
                    "label":"Option 1"
                  },
                  {
                    "value":"女",
                    "label":"Option 2"
                  }
                ],
                "required":true,
                "width":"",
                "remote":false,
                "remoteOptions":[

                ],
                "props":{
                  "value":"value",
                  "label":"label"
                },
                "remoteFunc":"func_1603088262000_68772",
                "disabled":false
              },
              "name":"性别",
              "key":"1603088262000_68772",
              "model":"sex",
              "rules":[
                {
                  "required":true,
                  "message":"性别必须填写"
                }
              ]
            }
          ],
          "config":{
            "labelWidth":100,
            "labelPosition":"right",
            "size":"small",
            "customClass":""
          }
        },
        list:{}
      }
    },
    created() {
      this.fetchData();
    },
    methods: {
      fetchData() {
        let that = this
        get(this.$route.query.id).then(resp => {
          this.list = resp.data.result
          if (this.list.control != null){
           this.jsonData = this.list.control
          }
          this.$nextTick(()=>{
            that.$refs.makingform.setJSON(that.jsonData)
          })
        })
      },
      handleSubmit(){
        this.list.control = this.$refs.makingform.getJSON()
        update(this.list).then(resp => {
          this.submitCallback(resp);
        })
      },
      submitCallback(resp) {
        if (resp.status === 200) {
          this.$message.success(resp.data.message);
          this.$router.push({path: '/evaluation/form/list'})
        }
      },
      goBack(){
        this.$router.go(-1);
      }
    }
  }
</script>
<style type="text/scss" lang="scss">
  .evl-marking .widget-form-list{
    margin: 0 auto!important;
    padding: 50px 0;
    width: 400px;
  }
</style>
